import React from "react"

class GrantHeaderComponent extends React.Component {

	render() {
		const { title } = this.props.row;
		const left = title.substr(0, title.indexOf("("));
		const right = title.substr(left.length + 1, title.length - left.length + 1);
		return (
			<div className="grant-header">
			  <div>
				<span>{left}</span>
				{right && <span style={{ fontSize: "13px" }}>({right}</span>}
			  </div>
			  <button
				onClick={this.props.onToggleGrants}
				title={
				  (this.props.row.isShown ? "Masquer" : "Afficher") +
				  " le détail des subventions"
				}
			  >
				<i
				  className={
					"fa fa-chevron-" + (this.props.row.isShown ? "up" : "down")
				  }
				/>
			  </button>
			</div>
		  );
	}

}

export default GrantHeaderComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grant-header-component.js